<template>
  <PayProvider v-if="provider" :provider=provider />
</template>

<script>
import axios from '@/utils/axios-http'
import { useRoute } from 'vue-router'
import { inject, onMounted, ref } from 'vue'
import PayProvider from '@/components/PayProvider.vue'
import router from '@/utils/router'

export default {
  name: 'ProviderView',
  components: {
    PayProvider: PayProvider
  },
  setup (props, context) {
    const { storage, setStorage } = inject('storage')

    setStorage('showBack', true)

    const route = useRoute()
    Object.entries(route.query).forEach(([key, value]) => {
      setStorage(key, value)
    })
    router.push({ name: 'provider', params: { providerId: route.params.providerId } })

    const provider = ref()
    const data = {
      params: {
        is_external: process.env.VUE_APP_IS_EXTERNAL === 'true'
      }
    }

    const getProvider = () => {
      axios.get(`providers/providers/${route.params.providerId}`, data)
        .then(response => {
          console.log(response.data)
          if (response.data && response.data.provider) {
            provider.value = response.data.provider
            setStorage('overlay', false)
            setStorage('provider', provider)
            setStorage('denominations', [])

            if (storage.provider.type_id === 2) {
              const denominations = ref()
              axios.get(`providers/denominations/${storage.provider.id}`, data)
                .then(response => {
                  if (response.data && response.data.denominations) {
                    denominations.value = response.data.denominations
                    setStorage('denominations', denominations)
                  }
                })
            }

            if (storage.provider.type_id === 4) {
              if (storage.provider.number_of_vouchers) {
                if (storage.amount) {
                  storage.number_of_vouchers = Math.max(parseInt(storage.amount / storage.provider.limits.min), 1)
                  storage.amount = storage.provider.limits.min * storage.number_of_vouchers
                } else {
                  storage.amount = storage.provider.limits.min
                  storage.number_of_vouchers = 1
                }
              } else {
                storage.amount = storage.provider.limits.min
              }
            }

            if (storage.provider.type_id === 6) {
              storage.field1 = ''
              const range = storage.provider.ranges[1]
              if (range) {
                storage.currency = range.currency
              } else {
                storage.currency = 'USDT'
              }
            }

            Object.entries(provider.value.fields).forEach(([key, value]) => {
              if (!storage['field' + value.id]) {
                setStorage('field' + value.id, '')
              }
            })
          }
        })
        .catch(function () {
          setStorage('overlay', false)
          router.push({ name: '404' })
        })
    }

    onMounted(() => {
      getProvider()
    })

    return {
      provider
    }
  }
}
</script>
